export enum EMetricBuilderAction {
  NEW,
  EDIT,
}

export enum EMetricType {
  TIME_INTERVAL,
  SESSIONS,
  COMPOSITE,
}
export enum EGenericMetricType {
  TIME_INTERVAL,
  CONVERSION_RATE,
  CONVERSION_COUNT, // metric type = sessions and calculation = number
}

export enum EWithinUnitType {
  SECOND = 'seconds',
  MINUTE = 'minutes',
  HOUR = 'hours',
}

export enum ECalculationType {
  CONVERSION_RATE = 'conversion_rate',
  NUMBER = 'number',
  AVERAGE = 'average',
}

export enum EPairType {
  FIRST_FIRST = 'first_first',
  LAST_FIRST = 'last_first',
}

export enum EIsMultipleType {
  FIRST,
  MULTIPLE,
}

export enum EOccurrenceType {
  MULTIPLE = 'multiple_attempts',
  FIRST = 'first_attempt',
  MULTIPLE_PAIR = 'multiple_pairs',
  FIRST_PAIR = 'first_pair',
  SESSIONS = 'sessions',
}

// [HP-8240] Remove the `is_deployed` field and leave only the `status` field, which represents whether the state is deployed or not.
// https://conviva.atlassian.net/wiki/spaces/APP/pages/2549743885/Backend+Unify+the+resource+dimension+metric+mapped+event+flow+status+in+API
export enum EStatus {
  UNDEPLOYED = 0,
  DEPLOYED = 1,
}

export enum EDraftStatus {
  notDraft,
  isDraft,
}

export enum ESortOrder {
  NORMAL = 0,
  DESC = 1,
  ASC = 2,
}

export enum ESystemType {
  EMP = 'emp',
  Trends = 'trends',
}

export enum EAttributeType {
  Event = 1,
  Global = 2,
}

export enum ECategoryType {
  CONTENT = 'content',
  DEVICE = 'device',
  GEO = 'geo',
  SCREEN = 'screen',
  NETWORK = 'network',
  EVENTS = 'events',
  ERRORS = 'errors',
  PAGE = 'page',
  CUSTOM = 'custom',
  GLOBAL_TAGS = 'global_tags',
  EVENT_TAGS = 'event_tags',
}

export enum EStatusStr {
  ALL = 'All',
  Deployed = 'Deployed',
  Undeployed = 'Undeployed',
}

export enum EStringOp {
  EQUALS = 'equals',
  NOT_EQ = 'not equals',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not contains',
  IS_NOT_EMPTY = 'is not empty',
  IS_EMPTY = 'is empty',
  STARTS_WITH = 'starts with',
  ENDS_WITH = 'ends with',
  MATCH_PATTERN = 'match pattern',
}

export enum EColumnType {
  NUMBER = 'Number',
  NAME = 'Name',
  STATUS = 'Status',
  CATEGORY = 'Category',
  TYPE = 'Type',
  LIST = 'List',
  USER = 'User',
  DATE = 'Date',
  ACTION = 'Action',
}

export enum EBlockedEventType {
  ALL = 'All',
  BLOCK_ALL = 'Block All',
  BLOCK_BY_RULES = 'Block by Rules',
}
